<template>
    <div
        class="w-full cursor-default py-4 min-h-20 px-6 list-transition-item opacity-100 flex flex-col justify-center"
        @click="isLocked ? '' : $emit('select')"
    >
        <div class="flex flex-row w-full h-full justify-between items-center">
            <div
                class="flex-row flex items-center "
                :style="
                    drawerActive !== undefined
                        ? 'width:calc(100% - 46px)'
                        : 'width:100%'
                "
            >
                <checked-icon
                    v-if="isFinished"
                    :fillClass="'fill-primary'"
                    class="mr-4"
                />
                <lock-closed-icon
                    v-else-if="isLocked"
                    :fillClass="'fill-grey'"
                    class="mr-4"
                />
                <div
                    class="flex flex-col justify-start items-center"
                    style="width:calc(100% - 40px)"
                >
                    <div
                        class="font-semibold text-base w-full transition-colors select-none"
                        :class="isFinished ? 'text-primary' : 'text-grey'"
                    >
                        {{ text }}
                    </div>
                    <slot name="description" />
                </div>
            </div>
            <icon-container
                v-if="drawerActive !== undefined"
                class=" transition-all transform"
                :class="drawerActive ? 'rotate-180' : ''"
                icon="SimpleArrowIcon"
                :iconSize="'4'"
                iconFill="fill-grey"
            />
        </div>
    </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";
import IconContainer from "../../../components/helper/IconContainer.vue";
import LockClosedIcon from "../../../components/icons/LockClosedIcon.vue";

export default defineComponent({
    components: { LockClosedIcon, IconContainer },
    name: "SidebarCard",
    props: {
        isFinished: {
            type: Boolean,
            default: false,
        },
        isLocked: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            required: true,
        },
        drawerActive: {
            required: false,
        },
    },
    emits: ["select"],
});
</script>
